import React, { Component } from 'react'
import { Row, Form, Button, Select, Input, Col } from 'antd'
// import PinYin from 'pinyin';
// import slug from 'limax';
import { api, app } from '../../app'

const FormItem = Form.Item
const Option = Select.Option
const TextArea = Input.TextArea

// const pinyinlite = require('pinyinlite');

function displayRender(label) {
    return label[label.length - 1]
}

class FirstLogin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            info: {},
            bloodtypeList: []
        }
    }

    setData = (data) => app.setStateSync(this, data)

    async componentDidMount() {
        this._isMounted = true
        let infoStr = sessionStorage.getItem('firstLoginData')
        if (infoStr) {
            let info = JSON.parse(infoStr)
            await this.setData({ info })
            await this.bloodtypeSource()
        } else {
            this.props.history.replace('/')
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 提交信息
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                if (this.state.loading) return false
                const params = {
                    nickname: values.nickname,
                    passport: values.passport,
                    bloodtype: values.bloodtype,
                    drughis: values.drughis,
                    emecontact: values.emecontact,
                    emecontactphone: values.emecontactphone,
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                }
                await this.setData({ loading: true })
                let { flag, msg } = await app.post(api.UserInfoFill, params)
                if (flag === 1) {
                    app.setLoginInfo(this.state.info)
                    this.props.history.replace('/')
                } else {
                    app.alert(msg, 'error')
                }
                await this.setData({ loading: false })
            }
        })
    }

    /**
     * 拼音编写
     * @param str
     * @returns {*}
     */
    handlePinYin = (str) => {
        // this.setState({pinyin: '', pinyinedit: false});
        let pinyin = ''
        try {
            // pinyin = slug(str, {tone: false, maintainCase: true});
        } catch (e) {
            console.error(e)
            app.alert('姓名拼音识别错误，请自行填写')
        } finally {
            this.props.form.setFieldsValue({ pinyin })
            this.setState({ pinyin, pinyinedit: false })
        }
    }

    /**
     * 拼音自定义检测
     * @param rule
     * @param value
     * @param callback
     */
    handelPinYinCheck = (rule, value, callback) => {
        const { getFieldValue } = this.props.form, reg = /^[a-zA-Z]+$/, vname = getFieldValue('vname')
        if (value && !reg.test(value)) {
            callback('请输入拼音字母！')
            // this.handlePinYin(vname);
        }
        callback()
    }

    handelNameChange = (e) => {
        const { value } = e.target
        this.handlePinYin(value)
    }

    /**
     * 血型数据源
     */
    async bloodtypeSource() {
        const params = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
        }
        let { flag, data, msg } = await app.post(api.UBloodtypeSelectLists, params)
        const state = {}
        if (flag === 1) {
            state.bloodtypeList = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 9, offset: 1 },
        },
            { getFieldDecorator } = this.props.form,
            { info, loading, bloodtypeList } = this.state,
            { vname, teampositionname, teamname, team, idno, nickname, passport, bloodtype, drughis, emecontact, emecontactphone, pinyin } = info
        return (
            <div className="first_login">
                <div className="logo iconfont icon-logo_"></div>
                <div className="fl-content">
                    <Row className="cl_top">
                        <Col style={{ height: '100%', background: '#00A0E8' }} span={6} />
                        <Col style={{ height: '100%', background: '#25589A' }} span={6} />
                        <Col style={{ height: '100%', background: '#E8A700' }} span={6} />
                        <Col style={{ height: '100%', background: '#4BB0B6' }} span={6} />
                    </Row>
                    <div className="clc_title">个人信息</div>
                    <Row className="form">
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem
                                {...formItemLayout}
                                label="姓名"
                                className="readonly"
                            >
                                {getFieldDecorator('vname', { initialValue: vname })(
                                    <Input readOnly />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="姓名拼音"
                                className="readonly"
                            >
                                {getFieldDecorator('pinyin', { initialValue: pinyin })(
                                    <Input readOnly />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="职务"
                                className="readonly"
                            >
                                {getFieldDecorator('teampositionname', { initialValue: teampositionname })(
                                    <Input readOnly />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="所属分队"
                                className="readonly"
                            >
                                {getFieldDecorator('teamname', { initialValue: teamname })(
                                    <Input readOnly />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="队伍编号"
                                className="readonly"
                            >
                                {getFieldDecorator('team', { initialValue: team })(
                                    <Input readOnly />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="身份证号码"
                                className="readonly"
                            >
                                {getFieldDecorator('idno', { initialValue: idno })(
                                    <Input readOnly />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="代号"
                            >
                                {getFieldDecorator('nickname', {
                                    rules: [{ required: true, message: '请填写您的代号!' }],
                                    initialValue: nickname
                                })(
                                    <Input placeholder="请填写您的代号" />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="护照"
                            >
                                {getFieldDecorator('passport', { initialValue: passport })(
                                    <Input placeholder="请填写您的护照号" />
                                )}
                            </FormItem>
                            <FormItem
                                label="血型"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('bloodtype', {
                                    rules: [{ required: true, message: '请选择您的血型!' }],
                                    initialValue: bloodtype || undefined
                                })(
                                    <Select style={{ width: '60%' }} placeholder="请选择您的血型">
                                        {
                                            bloodtypeList.map(b => {
                                                return (
                                                    <Option key={b.value} value={b.value}>{b.title}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="药物过敏史"
                            >
                                {getFieldDecorator('drughis', { initialValue: drughis })(
                                    <TextArea placeholder="请填写您的药物过敏史" autosize={{ maxRows: 4 }} />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="紧急联系人"
                            >
                                {getFieldDecorator('emecontact', {
                                    rules: [{ required: true, message: '请输入紧急联系人姓名!' }],
                                    initialValue: emecontact
                                })(
                                    <Input placeholder="请输入紧急联系人姓名" />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="紧急联系人电话"
                            >
                                {getFieldDecorator('emecontactphone', {
                                    rules: [{ required: true, message: '请输入紧急联系人电话!' }],
                                    initialValue: emecontactphone
                                })(
                                    <Input placeholder="请输入紧急联系人电话" />
                                )}
                            </FormItem>
                            <FormItem
                                style={{ textAlign: 'center' }}
                            >
                                <Button type="primary" htmlType="submit" loading={loading}>提交</Button>
                            </FormItem>
                        </Form>
                    </Row>
                </div>
            </div>
        )
    }
}

export default Form.create()(FirstLogin)



// WEBPACK FOOTER //
// ./src/routes/login/FirstLogin.jsx